const actions = {
  GET_ALL_PRODUCT_BEGIN: 'GET_ALL_PRODUCT_BEGIN',
  GET_ALL_PRODUCT_SUCCESS: 'GET_ALL_PRODUCT_SUCCESS',
  GET_ALL_PRODUCT_ERR: 'GET_ALL_PRODUCT_ERR',

  SET_ALL_PRODUCT_BEGIN: 'SET_ALL_PRODUCT_BEGIN',
  SET_ALL_PRODUCT_SUCCESS: 'SET_ALL_PRODUCT_SUCCESS',
  SET_ALL_PRODUCT_ERR: 'SET_ALL_PRODUCT_ERR',

  GET_SELECTED_PRODUCT_BEGIN: 'GET_SELECTED_PRODUCT_BEGIN',
  GET_SELECTED_PRODUCT_SUCCESS: 'GET_SELECTED_PRODUCT_SUCCESS',
  GET_SELECTED_PRODUCT_ERR: 'GET_SELECTED_PRODUCT_ERR',

  SET_SELECTED_PRODUCT_BEGIN: 'SET_SELECTED_PRODUCT_BEGIN',
  SET_SELECTED_PRODUCT_SUCCESS: 'SET_SELECTED_PRODUCT_SUCCESS',
  SET_SELECTED_PRODUCT_ERR: 'SET_SELECTED_PRODUCT_ERR',

  getAllProductBegin: () => {
    return {
      type: actions.GET_ALL_PRODUCT_BEGIN,
    };
  },

  getAllProductSuccess: data => {
    return {
      type: actions.GET_ALL_PRODUCT_SUCCESS,
      data,
    };
  },

  getAllProductErr: err => {
    return {
      type: actions.GET_ALL_PRODUCT_ERR,
      err,
    };
  },

  setAllProductBegin: () => {
    return {
      type: actions.SET_ALL_PRODUCT_BEGIN,
    };
  },

  setAllProductSuccess: data => {
    return {
      type: actions.SET_ALL_PRODUCT_SUCCESS,
      data,
    };
  },

  setAllProductErr: err => {
    return {
      type: actions.SET_ALL_PRODUCT_ERR,
      err,
    };
  },

  getSelectedProductBegin: () => {
    return {
      type: actions.GET_SELECTED_PRODUCT_BEGIN,
    };
  },

  getSelectedProductSuccess: data => {
    return {
      type: actions.GET_SELECTED_PRODUCT_SUCCESS,
      data,
    };
  },

  getSelectedProductErr: err => {
    return {
      type: actions.GET_SELECTED_PRODUCT_ERR,
      err,
    };
  },

  setSelectedProductBegin: () => {
    return {
      type: actions.SET_SELECTED_PRODUCT_BEGIN,
    };
  },

  setSelectedProductSuccess: data => {
    return {
      type: actions.SET_SELECTED_PRODUCT_SUCCESS,
      data,
    };
  },

  setSelectedProductErr: err => {
    return {
      type: actions.SET_SELECTED_PRODUCT_ERR,
      err,
    };
  },
};

export default actions;

